import BaseComponent from '../base/baseComponent';
import Swiper, { Pagination, Navigation, Thumbs, Controller, A11y } from 'swiper';
Swiper.use([Pagination, Navigation, Thumbs, Controller, A11y]);
export default class PdpCarousel extends BaseComponent {
    constructor(element) {
        super(element);
        this.swiperHandler();
    }
    swiperHandler() {
        let galleryThumbs = null;
        let thumbsSlides = this._el.querySelectorAll('.thumbs-wrapper .swiper-thumb');
        let slides = this._el.querySelectorAll('.slide-wrapper .swiper-slide');
        if (thumbsSlides && thumbsSlides.length > 0 && slides && slides.length === thumbsSlides.length) {
            galleryThumbs = new Swiper(this._el.querySelector('.thumbs-wrapper'), {
                spaceBetween: 24,
                slidesPerView: 3,
                loop: true,
                watchSlidesProgress: true,
                centeredSlides: true,
                slideToClickedSlide: true,
                loopedSlides: 3,
            });
        }
        const swiper = new Swiper(this._el.querySelector('.slide-wrapper'), {
            slidesPerView: 1,
            loopedSlides: 3,
            centeredSlides: false,
            loop: slides.length <= 1 ? false : true,
            navigation: {
                enabled: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                enabled: true,
            },
            a11y: {
                enabled: true,
                containerRoleDescriptionMessage: 'carousel',
                itemRoleDescriptionMessage: 'slide',
                slideRole: 'group'
            },
            breakpoints: {
                1024: {
                    pagination: {
                        enabled: false,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next-pdp',
                        prevEl: '.swiper-button-prev-pdp',
                        enabled: true,
                    },
                },
            },
        });
        if (galleryThumbs) {
            galleryThumbs.controller.control = swiper;
            swiper.controller.control = galleryThumbs;
        }
    }
}
